import store from "@/store";
import { Action, getModule, Module, Mutation, MutationAction, VuexModule } from "vuex-module-decorators";
import { IVisits, IVisitsListItem, VisitPaymentMethods } from "@/entity/visits/visit.types";
import { PaginationRequestType } from "@/entity/common/pagination.types";
import {
    NewVisitCreateRequestType,
    VisitCreateRequestType,
    VisitProductsCreate,
} from "@/form/visits/visitCreate.types";
import { ResponseDataType, VisitResponseDataType } from "@/form/form.types";
import { prepareFormData } from "@/store/utils/formDataHelper";
import { IStoreReady } from "@/store/lib/storeSupport";
import { VisitTypePayRequestType } from "@/form/visits/Pay/Visit.types";
import { VisitProduct } from "@/entity/visits/vProducts";
import { visitProductsRequestType } from "@/form/visits/Products/visitProducts.types";

@Module({
    namespaced: true,
    name: "visits",
    store,
    dynamic: true,
})
class VisitsModule extends VuexModule implements IStoreReady {
    visits: IVisits | null = null;
    visit: IVisitsListItem | null = null;
    products: VisitProduct[] | null = null;
    visitsLoaded = false;
    visitLoaded = false;
    workersInVisits: IVisitsListItem[] | undefined;
    ready = false;

    @MutationAction
    async fetchAll(data?: PaginationRequestType): Promise<{ visits: IVisits; visitsLoaded: boolean }> {
        let visitsLoaded = false;
        const visits = await store.$repository.visits.fetchAll(prepareFormData(data));
        if (visits) {
            visitsLoaded = true;
        }
        return { visits, visitsLoaded };
    }
    @MutationAction
    async fetchData(data: PaginationRequestType): Promise<{ visit: IVisitsListItem; visitLoaded: boolean }> {
        let visitLoaded = false;
        const visit = await store.$repository.visits.fetchData(data);
        if (visit) {
            visitLoaded = true;
        }
        return { visit, visitLoaded };
    }

    @Action({ rawError: true })
    async fetchVisitProducts(visit_id: number): Promise<{ products: VisitProduct[] }> {
        const products = await store.$repository.visits.fetchVisitProducts(visit_id);
        return { products };
    }

    @Action({ rawError: true })
    async saveVisitProducts(data: visitProductsRequestType): Promise<ResponseDataType> {
        return await store.$repository.visits.saveVisitProducts(data);
    }

    @Action({ rawError: true })
    async createNew(data: NewVisitCreateRequestType): Promise<VisitResponseDataType> {
        return await store.$repository.visits.createNew(data);
    }

    @Mutation
    VisitsByWorker(id: number): void {
        this.workersInVisits = this.visits?.data.filter((visit) => visit.cosmetologists_id === id);
    }

    @Mutation
    saveVisitRuntime(data: { id: number; visit_dt: string; visit_dt_end: string }): void {
        const vData = this.visits?.data.filter((visit) => visit.id === data.id);

        if (vData) {
            vData[0].visit_dt = data.visit_dt;
            vData[0].visit_dt_end = data.visit_dt_end;
        }
    }

    @Action({ rawError: true })
    async create(data: VisitCreateRequestType): Promise<ResponseDataType> {
        return await store.$repository.visits.create(data);
    }
    @Action({ rawError: true })
    async update(data: VisitCreateRequestType): Promise<ResponseDataType> {
        return await store.$repository.visits.update(data);
    }
    @Action({ rawError: true })
    async updateNew(data: NewVisitCreateRequestType): Promise<VisitResponseDataType> {
        return await store.$repository.visits.updateNew(data);
    }

    @Action({ rawError: true })
    async delete(data: { id: number }): Promise<ResponseDataType> {
        return await store.$repository.visits.delete(data);
    }
    @Action({ rawError: true })
    async pay(data: VisitTypePayRequestType): Promise<ResponseDataType> {
        return await store.$repository.visits.pay(data);
    }
    @Action({ rawError: true })
    async fetchPaymentMethods(data: { visit_id: number }): Promise<VisitPaymentMethods> {
        return await store.$repository.visits.fetchPaymentMethods(data);
    }

    @Mutation
    setReady(st: boolean) {
        this.ready = st;
    }

    @Mutation
    clearData(){
        this.visits = null;
        this.visit = null;
    }
}

export const VisitsStore = getModule(VisitsModule);
